<template>
	<div>
		<!-- TODO : afficher ici les types d'enfants disponible du noeud sélectionner avec des sous-menus Sélectionner / Déselectionner pour chacun d'eux -->
		<!-- @description Ajouter un attribut propagation="false" un élément html permet de définir que le menu contextuel ne se ferme pas lors d'un clic sur cet item -->
		<copy-data-menu-item :CopyMenu.sync="copyInfoMenu" :Variant="Variant" :key="FilterNode.Id"/>
		<div v-if="FilterNode.RightBound-FilterNode.LeftBound > 1">
			<hsc-menu-separator />
			<hsc-menu-item v-if="menuSelection == true" propagation="false">
			<div slot="body" @click="menuSelection = false" propagation="false">
				<b-icon icon="check-square-fill"  propagation="false" :variant="Variant" font-scale="1.2" class="mr-2" />{{ $t('Mode') }} : {{ $t('Select') }}
			</div>
			</hsc-menu-item>
			<hsc-menu-item v-else propagation="false">
				<div slot="body" @click="menuSelection = true" propagation="false">
					<b-icon icon="square" propagation="false" :variant="Variant" font-scale="1.2" class="mr-2" />{{ $t('Mode') }} : {{ $t('Unselect') }}
				</div>
			</hsc-menu-item>
			<hsc-menu-separator />
		</div>
		<filter-menu-item :MenuItems="localMenu" :FilterNode="FilterNode" :MenuSelection="menuSelection" />
	</div>
</template>

<script lang="ts">
	import { Component, InjectReactive, Prop, Vue, Watch } from "vue-property-decorator";
	import FilterMenuItem from "./FilterMenu/FilterMenuItem.vue";
	import CopyDataMenuItem from "./FilterMenu/CopyDataMenuItem.vue";
	import MenuItem from "@/types/MenuItem";
	import TreeNode from "@/types/TreeNode";
	import { Getter } from "vuex-class";
	import { API_URL } from "@/App.settings";
	import axios from "axios";
	import { Dictionary } from "vue-router/types/router";
	import CopyInfoMenu from "@/types/CopyInfoMenu";

	/** Composant de menu de filtre des sous-types */
	@Component({
		name: 'filter-menu',
		components: {
			FilterMenuItem,
			CopyDataMenuItem
		}
	})
	export default class FilterMenu extends Vue {
        /** Variant de couleur à appliquer */
        @Prop()
        public Variant!: string;

		@Prop()
		public FilterNode!: TreeNode;

		/** Items du menu */
		@Prop()
		public Menu!: MenuItem[];

        /** Indique si le contextmenu est en selection ou deselection */
        private menuSelection: boolean = true;

		/** Nom de l'instance d'arborescence à utiliser */
		@InjectReactive()
		private sourceFilterTree!: string;

		private localMenu: MenuItem[] = [];

		/** Indication si utilisateur superviseur */
        @Getter("SessionStore/GetUserIsSupervisor")
        private isUserSupervisor!: boolean;

		/** Menu pour copier des informations sur le noeud (nom, Invariant...) dans le press papier*/
		private copyInfoMenu: CopyInfoMenu = null ;
	

		/** Affiche ou masque les MenuItems en fonction du noeud sélectionné et des contraintes associées à son ObjectType */
		@Watch('FilterNode', { immediate: true })
		@Watch('Menu', { immediate: true })
		private async updateMenu() {
			this.localMenu = this.Menu;

			let descObjectTypes: string[] = this.$store.getters[this.sourceFilterTree + '/DescObjectTypes'](this.FilterNode, true);
			
			this.localMenu.forEach(x => {
				if (x.SubItems)
					x.Visible = this.displayMenuItem(x.SubItems, descObjectTypes);
			});

			//Vue que le watcher est aussi sur le menu, on pourrait entrer dans cette méthode sans avoir de noeud définie
			if(this.FilterNode.Id != undefined){
				await this.loadCopyMenu();
			}
		}


		private async loadCopyMenu(){
			const args: Dictionary<any> = {};
			args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
			args["ObjectId"] = this.FilterNode.Id;

			await axios.post(API_URL + "/object/InitContextCopyMenu", args).then((response) => {
				if (response && response.data) {
					this.copyInfoMenu = response.data;
					console.debug(`FilterMenu - loadCopyMenu : copyMenu ${JSON.stringify(this.copyInfoMenu)}`)
				}
			});
		}
	

		/** Affiche ou masque un ensemble d'item de menu si le TypeObject existe dans constraints   */
		/** @return Renvoi True uniquement si au moins un des enfants est visible */
		private displayMenuItem(menuItems: MenuItem[], descObjectTypes: string[]) {
			let result = false;
			menuItems.forEach(x => {
				x.Visible = (descObjectTypes.includes(x.ObjectType));
				// Pour afficher/masquer le parent si au moins un des enfants est visible
				if (x.Visible)
					result = true;
				
				// Boucle sur les enfants du menu
				this.displayMenuItem(x.SubItems, descObjectTypes);
			});

			return result;
		}

        private unwatchSourceFilterTree = undefined;

		created() {
				/** Calcul des noeuds sélectionnés */
				this.unwatchSourceFilterTree = this.$store.watch((state, getters) => getters[this.sourceFilterTree + '/InvolvedNodes'], (val: TreeNode[], oldValue: TreeNode[]) => {
				/** Obligé de tester si les InvolvedNodes sont différents car le watcher se déclenche lors du clone de l'arborescence dans FilterTreeBuilder lors du this.$store.registerModule(this.filterTreeStore, FilterTree);
				 * @see https://github.com/vuejs/vuex/issues/524 */
				
				if (JSON.stringify(val) != JSON.stringify(oldValue)){
                    if (val.length == 0)
						this.menuSelection = true;
                }
            }, { immediate: true });
		}

		beforeDestroy() {
			if (this.unwatchSourceFilterTree)
				this.unwatchSourceFilterTree();
		}
	}
</script>

<style scoped>
</style>